"use strict";

require("core-js/modules/es6.string.link");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.function.name");

require("core-js/modules/es6.regexp.to-string");

require("core-js/modules/es6.date.to-string");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.reflect.construct");

require("core-js/modules/es6.object.set-prototype-of");

require("core-js/modules/es6.object.create");

require("core-js/modules/es6.object.assign");

require("core-js/modules/es7.symbol.async-iterator");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SocialIcons = _interopRequireDefault(require("../SocialIcons"));

require("./styles.scss");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

var Footer = /*#__PURE__*/function (_React$Component) {
  _inherits(Footer, _React$Component);

  var _super = _createSuper(Footer);

  function Footer() {
    _classCallCheck(this, Footer);

    return _super.apply(this, arguments);
  }

  _createClass(Footer, [{
    key: "render",
    value: function render() {
      var _this = this;

      var copyrightNotice = "\xA9  ".concat(new Date().getFullYear(), " ").concat(this.props.name);
      return /*#__PURE__*/_react["default"].createElement("footer", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "container pl-4 pr-4"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "row"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-md-4 col-xl-5 d-none d-md-block"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "pr-xl-4"
      }, this.props.children, /*#__PURE__*/_react["default"].createElement("p", {
        className: "rights"
      }, copyrightNotice))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-md-4"
      }, /*#__PURE__*/_react["default"].createElement("h5", null, "Contact"), /*#__PURE__*/_react["default"].createElement("dl", {
        className: "contact-list"
      }, /*#__PURE__*/_react["default"].createElement("dt", null, "Telephone:"), /*#__PURE__*/_react["default"].createElement("dd", null, this.props.contact.phone)), /*#__PURE__*/_react["default"].createElement("dl", {
        className: "contact-list"
      }, /*#__PURE__*/_react["default"].createElement("dt", null, "Address:"), Object.keys(this.props.contact.address).map(function (item) {
        return /*#__PURE__*/_react["default"].createElement("dd", {
          className: "mb-0"
        }, _this.props.contact.address[item], /*#__PURE__*/_react["default"].createElement("br", null));
      }))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "col-md-4 col-xl-3"
      }, /*#__PURE__*/_react["default"].createElement("h5", null, "Links"), /*#__PURE__*/_react["default"].createElement("ul", {
        className: "nav-list pl-0 mb-2 footerNav"
      }, this.props.pages.slice(1).map(function (p) {
        if (!p.subPages) return /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
          href: p.link
        }, p.name));else return /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
          href: p.subPages[0].link
        }, p.subPages[0].name));
      }), /*#__PURE__*/_react["default"].createElement("li", null, /*#__PURE__*/_react["default"].createElement("a", {
        href: "/privacy"
      }, "Privacy Policy"))), this.props.social && /*#__PURE__*/_react["default"].createElement(_SocialIcons["default"], _extends({
        className: "d-none d-md-block"
      }, this.props.social, {
        size: 20
      }))))), /*#__PURE__*/_react["default"].createElement("div", {
        className: "text-center copyright d-sm-block d-md-none"
      }, this.props.social && /*#__PURE__*/_react["default"].createElement(_SocialIcons["default"], this.props.social), copyrightNotice));
    }
  }]);

  return Footer;
}(_react["default"].Component);

Footer.propTypes = {
  contact: _propTypes["default"].shape({
    address: _propTypes["default"].arrayOf(_propTypes["default"].string.isRequired).isRequired,
    phone: _propTypes["default"].string.isRequired
  }).isRequired,
  name: _propTypes["default"].string,
  pages: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string.isRequired,
    link: _propTypes["default"].string,
    subPages: _propTypes["default"].shape({
      name: _propTypes["default"].string.isRequired,
      link: _propTypes["default"].string.isRequired
    })
  }).isRequired).isRequired,
  social: _propTypes["default"].objectOf(_propTypes["default"].string)
};
var _default = Footer;
exports["default"] = _default;